import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { actions } from 'src/features/user';

interface PageIndicatorProps {
  page: 1 | 2;
}

export const PageIndicator: React.FC<PageIndicatorProps> = ({ page }) => {
  const { t } = useTranslation('translation');
  const dispatch = useDispatch();
  const handleLeftClick = () => {
    if (page !== 1) {
      dispatch(actions.setPage({ page: 1 }));
    }
  };
  const handleRightClick = () => {
    if (page !== 2) {
      dispatch(actions.setPage({ page: 2 }));
    }
  };

  return (
    <ul
      className={css`
        height: 44px;
        line-height: 0;
        text-align: center;

        li {
          display: inline-flex;
          justify-content: center;
          align-items: center;

          &:nth-of-type(1) button span {
            box-shadow: ${page === 1 ? '0 0 0 4px #14c5b6' : 'none'};
          }
          &:nth-of-type(2) button span {
            box-shadow: ${page === 2 ? '0 0 0 4px #14c5b6' : 'none'};
          }
        }
        button {
          width: 44px;
          height: 44px;
        }
        span {
          display: inline-block;
          width: 16px;
          height: 16px;
          background: #d5d5d5;
          border-radius: 50%;
          box-sizing: content-box;
        }
      `}
      role="tablist"
    >
      <li>
        <button
          role="tab"
          aria-label={t('aria_indicator_1')}
          aria-current={page === 1}
          aria-controls="top-page-1"
          onClick={handleLeftClick}
        >
          <span />
        </button>
      </li>
      <li>
        <button
          role="tab"
          aria-label={t('aria_indicator_2')}
          aria-current={page === 2}
          aria-controls="top-page-2"
          onClick={handleRightClick}
        >
          <span />
        </button>
      </li>
    </ul>
  );
};
